// extracted by mini-css-extract-plugin
export var heroVideo = "InlineWebGLShowreel-module--heroVideo--g62ey";